import { BehaviorSubject } from 'rxjs';

interface SaveGraphics {
    id: string | undefined;
    features: any;
}

let initialGisInstanceState;
const gisInstanceLevel$ = new BehaviorSubject(initialGisInstanceState);

let featureCollections: SaveGraphics[] = [];
const featureCollections$ = new BehaviorSubject<SaveGraphics[] | null>(featureCollections);


export const arcgisStore = {
    gisInstance: {
        subscribe: (setState: any) => gisInstanceLevel$.subscribe(setState),
        setGisInstance: (gisInstance: any) => {
            gisInstanceLevel$.next(gisInstance);
        },
    },
};
